import React, { useEffect, useState } from 'react';
import './SkillsPanel.css';

interface SkillItem {
  name: string;
  description: string;
  path: string;
}

interface SkillsCatalog {
  generatedAt: string;
  count: number;
  skills: SkillItem[];
}

const SkillsPanel: React.FC = () => {
  const [catalog, setCatalog] = useState<SkillsCatalog | null>(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetch('/skills-catalog.json')
      .then((res) => res.json())
      .then((data) => setCatalog(data))
      .catch(() => setCatalog(null));
  }, []);

  const filtered = (catalog?.skills || []).filter((s) =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.description.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="skills-panel">
      <div className="skills-header">
        <h2>Skills Catalog</h2>
        <p className="skills-subtitle">{catalog ? `${catalog.count} skills • Generated ${new Date(catalog.generatedAt).toLocaleString()}` : 'Loading catalog…'}</p>
        <input
          className="skills-search"
          placeholder="Search skills…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="skills-grid">
        {filtered.map((s) => (
          <div key={s.name} className="skill-card">
            <div className="skill-name">{s.name}</div>
            <div className="skill-desc">{s.description}</div>
            <div className="skill-path">{s.path}</div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="skills-empty">No skills match your search.</div>
        )}
      </div>
    </div>
  );
};

export default SkillsPanel;
